export const formatBRL = (value = 0) => {
  if (isNaN(value)) {
    return;
  }

  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};
